import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/wifi.vue
var o = {
	name: "DtIconWifi",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--wifi"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Wifi",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M6 3a7 7 0 0 0-4.667 1.783.5.5 0 0 1-.666-.746 8 8 0 0 1 10.666 0 .5.5 0 1 1-.666.746A7 7 0 0 0 6 3Zm0 2.57a4.5 4.5 0 0 0-3.15 1.287.5.5 0 1 1-.7-.714 5.5 5.5 0 0 1 7.7 0 .5.5 0 1 1-.7.714A4.5 4.5 0 0 0 6 5.571Zm0 2.465a2 2 0 0 0-1.4.572.5.5 0 1 1-.7-.714 3 3 0 0 1 4.2 0 .5.5 0 0 1-.7.714A2 2 0 0 0 6 8.035ZM5.5 10a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=wifi.js.map